import isNotAuthenticatedGuard from "../guards/is-not-authenticated.guard";
import { checkAuthAction } from "../actions/check-auth.action";
import { wencesApi } from "@/api/wencesApi";
import AuthLayout from "../layouts/AuthLayout.vue";

import Login from "@/pages/Dashboard/Pages/Login.vue";
import Logout from "@/pages/Dashboard/Pages/Logout.vue";
import RecoverPassword from "@/pages/Dashboard/Pages/RecoverPassword.vue";
import Register from "@/pages/Dashboard/Pages/Register.vue";
import RegisterChoose from "@/pages/Dashboard/Pages/RegisterChoose.vue";
import RtlSupport from "@/pages/Dashboard/Pages/RtlSupport.vue";
// Mock components to replace non-existent imports
const Stripe = {
  template: "<div>Stripe component not available</div>",
  name: "Stripe",
};
const Shop = {
  template: "<div>Shop component not available</div>",
  name: "Shop",
};
const AnonymousOrder = {
  template: "<div>AnonymousOrder component not available</div>",
  name: "AnonymousOrder",
};
const AnonymousAccess = {
  template: "<div>AnonymousAccess component not available</div>",
  name: "AnonymousAccess",
};
const AnonymousResult = {
  template: "<div>AnonymousResult component not available</div>",
  name: "AnonymousResult",
};
const AnonymousWaitingOrder = {
  template: "<div>AnonymousWaitingOrder component not available</div>",
  name: "AnonymousWaitingOrder",
};
import Schedule from "@/pages/Schedule.vue";
import tickets from "@/pages/tickets.vue";
import MercadoPagoRedirect from "@/pages/MercadoPagoRedirect.vue";
const PersonalTrainersList = {
  template: "<div>PersonalTrainersList component not available</div>",
  name: "PersonalTrainersList",
};

export const authPages = {
  path: "/auth",
  name: "Authentication",
  beforeEnter: isNotAuthenticatedGuard,
  redirect: { name: "Login" },
  component: AuthLayout,
  children: [
    {
      path: "/login",
      name: "Login",
      component: Login,
      meta: { title: "Login" },
    },
    {
      path: "/logout",
      name: "Logout",
      component: Logout,
      meta: { title: "logout" },
    },
    {
      path: "/tickets",
      name: "tickets",
      component: tickets,
      meta: { title: "tickets" },
    },
    {
      path: "/mercadopago/oauth",
      name: "MercadoPagoRedirect",
      components: { default: MercadoPagoRedirect },
    },
    {
      path: "/schedule",
      name: "Schedule",
      component: Schedule,
      meta: { title: "Schedule" },
    },
    {
      path: "/login/:token",
      name: "Login",
      component: Login,
      meta: { title: "Login" },
    },
    {
      path: "/recoverpassword/:token",
      name: "RecoverPassword",
      component: RecoverPassword,
      meta: { title: "Password" },
    },
    {
      path: "/terms",
      name: "Terms",
      component: RtlSupport,
      meta: { title: "Terms" },
    },
    {
      path: "/login/:login/:name",
      name: "Login",
      component: Login,
      meta: { title: "Login" },
    },
    {
      path: "/register",
      name: "Register",
      component: Register,
      meta: { title: "Register", public: true },
      beforeEnter: async (to, from, next) => {
        try {
          const settingsResp = await wencesApi.get("/api/settings");
          const registerEnabled =
            settingsResp?.data?.data?.registerEnabled === true;
          if (!registerEnabled) {
            next("/login");
            return;
          }
        } catch (e) {
          next("/login");
          return;
        }

        const token = localStorage.getItem("token");
        if (!token) {
          next();
          return;
        }

        try {
          const statusResp = await checkAuthAction();
          if (statusResp?.ok && !statusResp?.transient) {
            next("/dashboard");
            return;
          }
        } catch (error) {
          // Si falla el check, dejamos pasar para no bloquear usuarios sin sesión real.
        }

        next();
      },
    },
  ],
};
